import document from 'document';

export const cookie = (() => { 
    const createCookie =  (name, value, days) => {
        let expires;
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toGMTString();
        } else {
            expires = '';
        }
        document.cookie = name + '=' + value + expires + '; path=/';
    }
    
    const cookieExists = (name) => {
        const cookies = document.cookie.split(';');
        return cookies.some(cookie => cookie.indexOf(`${name}=`) > -1);
    }

    const readCookie = (cookieName) => {
        var cookieString=RegExp(cookieName+"=[^;]+").exec(document.cookie);
        return decodeURIComponent(cookieString ? cookieString.toString().replace(/^[^=]+./,"") : "");
 
    };

    return {
        cookieExists,
        createCookie,
        readCookie
    }
})()